import { combineReducers } from 'redux';

import { newServices } from './newServices.reducer';
import { alert } from './alert.reducer';
import { hairdresser } from './hairdresser.reducer';
import { salon,salonList } from './salon.reducer';
import { hairdresserReview } from './review.reducer';
import { user } from './user.reducer';
import { setting } from './setting.reducer';
import {booking, createBooking, hairdresserBooking, userBookingState} from './booking.reducer';
import {userReview} from "./userreview.reducer";
import {upcomingOrPastBooking} from "./upcoming&pastBooking.reducer";
import {services} from "./services.reducer";
import {termsAndConditions,privacyPolicy,gdpr,hairdresserTermsAndConditions} from "./page.reducer";
import { calender } from './calender.reducer';
import { hairdresserClient,hairdresserClientCsv,selectedClient,hairdresserClientListState } from './client.reducer';
import { clientDetail } from './clientDetail.reducer';
import { staff,staffService,staffServiceDetail,staffRota,dairyFilterData,dairyStaffOrderList,activeFilterStatus } from './staff.reducer';
import { categories } from './category.reducer';
import { hairdresserServices,selectedService,salonOwnerDataInfo } from './hairdresserServices.reducer';
import { event } from './event.reducer';
import { bankDetails } from './bank.reducer';
import { selectCheckoutItem,selectedCheckoutList } from './product.reducer';
import { selectService,selectedServiceList } from './service.reducer';
import { updateMarketingData,getSalonMarketingSetting, marketingSettingNavigation } from './marketing.reducer';
import { selectVoucher, selectedVoucherList, voucherList, voucherByCode, voucherByRedemptionCode } from './voucher.reducer';


import {
  hairdresserNewBookingStaff,
  hairdresserNewBookingClient,
  hairdresserNewBookingService,
  hairdresserNewBookingData,
  selectHairdresserBookingDate,
  selectHairdresserBookingTime,
  clientBookingSlots,
  updateBookingInfo
} from './createbooking.reducer';

import {payoutList,cardReaderList} from "./paymentList.reducer";
import { notifications } from './notifications.reducer';
import { clientPhotos } from './clientPhotos.reducer';
import { diarySharing } from './diarySharing.reducer';
import { minimisedBooking } from './minimisedBooking.reducer';

const rootReducer = combineReducers({
  newServices,
  user,
  alert,
  hairdresser,
  salon,
  hairdresserReview,
  setting,
  booking,createBooking,
  userReview,
  salonList,
  upcomingOrPastBooking,
  services,
  termsAndConditions,privacyPolicy,gdpr,
  calender,
  hairdresserClient,
  hairdresserClientCsv,
  hairdresserClientListState,
  clientDetail,
  staff,
  hairdresserTermsAndConditions,
  categories,
  hairdresserServices,
  staffService,
  staffServiceDetail,
  staffRota,
  dairyFilterData,
  activeFilterStatus,
  hairdresserBooking,
  event,
  bankDetails,
  payoutList,
  cardReaderList,
  dairyStaffOrderList,
  selectCheckoutItem,
  selectService,
  selectedServiceList,
  selectedCheckoutList,
  selectedClient,
  selectedService,
  hairdresserNewBookingStaff,
  hairdresserNewBookingService,
  hairdresserNewBookingClient,
  hairdresserNewBookingData,
  selectHairdresserBookingDate,
  selectHairdresserBookingTime,
  clientBookingSlots,
  userBookingState,
  updateBookingInfo,
  updateMarketingData,
  getSalonMarketingSetting,
  marketingSettingNavigation,
  salonOwnerDataInfo,
  selectVoucher,
  selectedVoucherList,
  voucherList,
  voucherByCode,
  voucherByRedemptionCode,
  notifications,
  clientPhotos,
  diarySharing,
  minimisedBooking,
});

export default rootReducer;
